// normalizeUtils.ts - Funktionen für die Normalisierung von Trampolin-Bewegungen

// Define normalization rules for easier maintenance
export const normalizationRules: Array<[RegExp, string]> = [
    [/[oO]/g, '°'],  // Replace 'o' and 'O' with '°'
    [/\\/g, '/'],    // Replace backslash with forward slash
    [/\s/g, '']      // Remove all whitespace
  ];
  
  /**
   * Normalisiert eine Trampolin-Bewegungseingabe
   * - Ersetzt 'o'/'O' durch '°'
   * - Ersetzt '\' durch '/'
   * - Entfernt Leerzeichen
   * - Konvertiert zu Großbuchstaben
   */
  export const normalizeInput = (input: string): string => {
    if (!input) return '';
    
    // Apply all normalization rules
    let normalized = input;
    normalizationRules.forEach(([pattern, replacement]) => {
      normalized = normalized.replace(pattern, replacement);
    });
    
    // Convert to uppercase after all replacements
    normalized = normalized.toUpperCase();
    
    return normalized;
  };